export default "__VITE_ASSET__CeeETGbP__"